import { render, staticRenderFns } from "./mGamesBetInfoSingle.vue?vue&type=template&id=4417efa5&scoped=true"
import script from "./mGamesBetInfoSingle.vue?vue&type=script&lang=js"
export * from "./mGamesBetInfoSingle.vue?vue&type=script&lang=js"
import style0 from "./mGamesBetInfoSingle.vue?vue&type=style&index=0&id=4417efa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417efa5",
  null
  
)

export default component.exports